import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
export function Closing() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white py-24 px-6 text-center" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <FadeIn data-id="element-61">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-green mb-4" data-id="element-62">
            Puedes seguir buscando información sin rumbo…
          </h2>
          <p className="text-2xl md:text-3xl font-serif text-brand-green/80 mb-6" data-id="element-63">
            O puedes empezar hoy con un sistema claro que te lleve paso a paso.
          </p>

          <p className="text-lg text-brand-text/70 mb-4" data-id="element-64">
            El momento perfecto no existe, pero empezar hoy sí hace la
            diferencia.
          </p>
          <p className="text-xl text-brand-green font-semibold mb-12" data-id="element-65">
            Accede ahora y comienza desde casa.
          </p>

          <Button onClick={goToCheckout} className="text-lg px-12 py-5" data-id="element-66">
            QUIERO ACCESO INMEDIATO AHORA
          </Button>
        </FadeIn>
      </div>
    </section>;
}